import styled, { css } from 'styled-components';
import { ReactComponent as IconEdit } from '@whitelabel/media/icons/small/edit.svg';
import {
  get,
  multiply,
  spacer,
  boxShadow,
  fontFamily,
  fontSize,
  gray,
  fontWeight,
  color,
  themeColor,
  zIndex,
  mediaBreakpointUp,
  lineHeight,
  fontStyle,
} from '@whitelabel/helpers/style';
import Button from '../../../Button';

const ellipseBorderWidth = `3px`;
const ellipseSize = css(multiply(spacer, 1.25));
const ellipseBaseColor = css(gray(300));
const marginBottoms = css`
  margin-bottom: ${spacer};
  ${mediaBreakpointUp('md')`
    margin-bottom: ${multiply(spacer, 1.5)};
  `}
`;

export const StyledGeoMultiQuotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${multiply(spacer, 21.875)};
  padding: ${spacer};
  background-color: ${color('white')};
  box-shadow: ${boxShadow('base')};

  ${mediaBreakpointUp('sm')`
    box-shadow: ${boxShadow('md')};
    padding: ${multiply(spacer, 1.5)};
  `}
`;

export const StyledText = styled.p`
  margin-bottom: 0;
  ${fontStyle('subtext')}
  color: ${gray(600)};
`;

export const StyledZipCodeText = styled(StyledText)`
  font-size: ${fontStyle('paragraph')};
`;

export const StyledZipCode = styled.span`
  display: inline-block;
  color: ${themeColor('primary')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('base')};
  font-family: ${fontFamily('base')};
  line-height: ${lineHeight('sm')};
`;

export const StyledIconEdit = styled(IconEdit)`
  width: ${spacer};
  height: ${spacer};
  margin: 0 0 0 ${multiply(spacer, 0.25)};
  color: ${gray(600)};
  vertical-align: top;
  cursor: pointer;
`;

export const StyledDivider = styled.hr`
  width: 100%;
  margin-top: 0;
  margin-bottom: ${spacer};
  border-top: ${get('borderWidth')} solid ${gray(300)};
`;

export const StyledLimitSelection = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${multiply(spacer, 16.125)};
  ${marginBottoms}
`;

export const StyledDecorationLine = styled.div`
  position: absolute;
  top: calc(${ellipseSize} / 2);
  left: 50%;
  width: ${multiply(spacer, 12)};
  border: ${ellipseBorderWidth} solid ${ellipseBaseColor};
  transform: translateX(-50%);
`;

export const StyledEllipse = styled.div`
  z-index: ${zIndex('content')};
  box-sizing: content-box;
  width: ${ellipseSize};
  height: ${ellipseSize};
  margin-top: ${ellipseBorderWidth};
  background-color: ${ellipseBaseColor};
  border-radius: 50%;
`;

export const StyledLimitText = styled.span`
  color: ${gray(600)};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('base')};
`;

export const StyledSingleLimit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${({
    // @ts-ignore ts-migrate(2339) FIXME: Property 'active' does not exist on type 'Pick<Det... Remove this comment to see the full error message
    active,
  }) =>
    active &&
    css`
      ${StyledEllipse} {
        margin-top: 0;
        background-color: ${themeColor('primary')};
        border: ${ellipseBorderWidth} solid ${color('white')};
        box-shadow: 0px 4px 8px rgba(255, 230, 0, 0.2), 0px 16px 10px rgba(0, 0, 0, 0.05);
      }

      ${StyledLimitText} {
        color: ${gray(700)};
      }
    `}
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-bottom: ${spacer};
`;

export const StyledTertiary = styled(Button)`
  margin-bottom: ${spacer};
  font-size: ${fontSize('base')};
`;

export const StyledLoadingWrapper = styled.div`
  padding: ${multiply(spacer, 5)} 0;
  color: ${themeColor('primary')};
`;
